module.exports = __webpack_public_path__ + "media/icons/badanie-techniczne@2x-54c32b8c.png";